<template>
    <span v-if="message" :class="classAttr">{{ message }}</span>
</template>

<script>
  export default {
    name: 'form-error',
    props: {
      message: {
        type: String,
        default: '',
      },
      classAttr: {
        type: String,
        default: 'uk-text-danger',
      }
    }
  };
</script>


<style scoped>

</style>
